import { store } from '@betacrew/jars-flux'
import { TIN_MATCH_MODALS_LOADING_STATE } from './constants';

export const componentKey = "RECIPIENT/TIN_MATCH"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setTinMatchConfirmationModalOpen: (state, action) => {
            state.tinMatchConfirmationModalOpen = action.payload
        },

        setTinMatchForAllRecipientsModalOpen: (state, action) => {
            state.tinMatchForAllRecipientsModalOpen = action.payload
        },

        setTinMatchProceedRequest: (state, action) => {
            state.tinMatchProceedRequest = action.payload
        },

        setTinMatchFinalReportModalOpen: (state, action) => {
            state.tinMatchFinalReportModalOpen = action.payload
        },

        setRequestedCount: (state, action) => {
            state.requestedCount = action.payload
        },

        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setTinMatchFees: (state, action) => {
            state.tinMatchFees = action.payload;
        },
        setIsTinMatchSelectAll: (state, action) => {
            state.isTinMatchSelectAll = action.payload;
        }

    },
    initialReducerState: {
        loadingState: { state: TIN_MATCH_MODALS_LOADING_STATE.GET_REQUESTED_COUNT_READY },
        // TIN match modals
        tinMatchConfirmationModalOpen: false,
        tinMatchForAllRecipientsModalOpen: false,
        tinMatchProceedRequest: false,
        tinMatchFinalReportModalOpen: false,

        requestedCount: {
            TinMatchingRequests: 0,
            AcceptedRequests: 0
        },

        tinMatchFees: 0,
        isTinMatchSelectAll: false,
    }
});

export const { setTinMatchConfirmationModalOpen, setTinMatchFees, setTinMatchForAllRecipientsModalOpen, setTinMatchProceedRequest, setTinMatchFinalReportModalOpen, setRequestedCount, setLoadingState, setIsTinMatchSelectAll } = actions;
